import * as Yup from 'yup';

export type SearchByOpts = 'address' | 'permit' | 'project_id' | 'client' | '';

export const ALL_OPT = {
  id: '',
  name: 'All',
};

export const SEARCH_TYPES = [
  { name: 'Select', id: '' },
  { name: 'Address', id: 'address' },
  { name: 'Permit Number', id: 'permit' },
  { name: 'Project Number', id: 'project_id' },
  { name: 'Client', id: 'client' },
];

export const PROJECT_TYPES = [
  { name: 'All', id: '' },
  { name: 'Regular Inspections', id: 'regular' },
  { name: 'Special Inspections', id: 'special' },
  { name: 'DOEE Inspections', id: 'doee' },
  { name: 'Legacy Projects', id: 'legacy' },
];

export const SWO_OPTS = [
  {
    id: 'true',
    name: 'Yes',
  },
  {
    id: 'false',
    name: 'No',
  },
];

export const PENDING_REQUESTS = [
  {
    id: 'hasPendingFiles',
    name: 'Has Pending Files',
  },
  {
    id: 'permitCompleteRequest',
    name: 'Has Permit Complete Request',
  },
  {
    id: 'hasCancelRequest',
    name: 'Has Cancel Request',
  },
];

export const STATUS_FILTERS = [
  { name: 'New', id: 'new' },
  { name: 'Confirmed', id: 'confirmed_booking' },
  { name: 'Past', id: 'past' },

  { name: 'Cancelled', idAsParent: 'cancelled', id: 'optgroup' },
  { name: 'Cancelled by Admin', id: 'cancelled_by_admin', parentId: 'cancelled' },
  { name: 'Cancelled by Client', id: 'cancelled_by_client', parentId: 'cancelled' },
  { name: 'Cancelled by Agency', id: 'cancelled_by_agency', parentId: 'cancelled' },
];

export interface FormValues {
  searchBy: SearchByOpts;
  query: string;
  agencyCompanyId: string;
  type: string;

  dateFrom: string | null;
  dateTo: string | null;

  states: string[];
  hasSwo: string;
  pendingRequests: string;
}

export const defaultValues: FormValues = {
  searchBy: '',
  query: '',
  agencyCompanyId: '',
  type: '',

  dateTo: null,
  dateFrom: null,

  states: [],
  hasSwo: '',
  pendingRequests: '',
};

const detailsFields = {};

export const getValidationSchema = () => {
  return Yup.object({
    ...detailsFields,
  });
};
